<template>
  <div dir="rtl" lang="ar" class="app-root">
    <GlobalToast />
    <nav-page v-if="showLayout"></nav-page>
    <main class="page-main">
      <router-view v-slot="{ Component }">
        <transition name="page-fade" mode="out-in" appear>
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <footer-page v-if="showLayout"></footer-page>
  </div>
</template>

<script setup>
import { onMounted, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import NavPage from "@/components/NavPage.vue";
import FooterPage from "@/components/FooterPage.vue";
import GlobalToast from "@/components/GlobalToast.vue";
import { useTheme } from "@/composables/useTheme";

import { initSocket, disconnectSocket } from "@/services/socketService";
import { requestNotificationPermission, onForegroundMessage } from "@/firebaseConfig";

const route = useRoute();
const store = useStore();
const { initTheme, isDarkMode } = useTheme();

const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);
const currentUser = computed(() => store.state.auth.user);

const showLayout = computed(() => {
  const isDashboard = route.path.startsWith('/admin') || route.path.startsWith('/dashboard');
  const isMaintenance = route.name === 'Maintenance';
  const isQuranReader = route.path.startsWith('/read-quran');
  return !isDashboard && !isMaintenance && !isQuranReader;
});



const loadAds = () => {
  setTimeout(() => {
    // كود Social Bar المعتمد لتصنيف Books
    const script1 = document.createElement('script');
    script1.src = 'https://pl28967121.profitablecpmratenetwork.com/7f/e5/19/7fe51927dcc92238a951db7a717f17ec.js';
    script1.async = true;
    document.body.appendChild(script1);
  }, 5000); 
};

onMounted(() => {
  store.dispatch('settings/fetchPublicSettings');
  initTheme();
  loadAds();
  
  if (isAuthenticated.value) {
    initSocket();
    requestNotificationPermission(currentUser.value?.id);
    onForegroundMessage();
    store.dispatch('notifications/fetchNotifications');
  }
});



// Watch for authentication changes to init/disconnect socket
watch(isAuthenticated, (newVal) => {
  if (newVal) {
    initSocket();
    requestNotificationPermission(currentUser.value?.id);
    store.dispatch('notifications/fetchNotifications');
  } else {
    disconnectSocket();
  }
});
</script>

<style>
/* 🌟 Beautiful Page Entry Animations - Premium Glassmorphism Style */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: all 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.page-fade-enter-from {
  opacity: 0;
  transform: translateY(25px) scale(0.98);
  filter: blur(8px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(1.02);
  filter: blur(4px);
}

/* Global Utility for Entrance - Staggered beautiful fade */
.animate-entrance {
  animation: entranceFadeSlide 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  opacity: 0; /* Starts hidden */
}

@keyframes entranceFadeSlide {
  0% {
    opacity: 0;
    transform: translateY(30px);
    filter: blur(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

/* Adding staggered delay classes for child elements */
.animate-delay-1 { animation-delay: 0.1s; }
.animate-delay-2 { animation-delay: 0.2s; }
.animate-delay-3 { animation-delay: 0.3s; }
.animate-delay-4 { animation-delay: 0.4s; }
.animate-delay-5 { animation-delay: 0.5s; }

.app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-main {
  flex: 1;
}
</style>
